import {Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Partner } from '../../shared/api/model/partner';
import {AgentService} from '../../shared/api/resources/agent/agent.service';
import * as moment from 'moment';
import {AgentCalendar} from '../../shared/api/model/agent-calendar';
import {StaticUtils} from '../../shared/utils/static-utils';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  providers: []
})
export class CalendarComponent implements OnInit, OnDestroy {
  private _sub: any;
  private _dateRange = {
    start: moment(),
    end: moment()
  };
  private _datePickerRange = 0;
  private _paxFilter = 0;

  moment = moment;
  partnerId: number;
  partner: Partner;
  calendar: AgentCalendar[];
  loadingEvents = true;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _agentService: AgentService) { }

  ngOnInit() {
    this._sub = this._route.params.subscribe(params => {
      this.partnerId = parseInt(params['id'], 10);
      this._agentService.getSupplier(this.partnerId).subscribe(
        (partner: Partner) => {
          this.partner = partner;
        }
      );

      this.reloadEvents();
    });
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  reloadEvents() {
    this.loadingEvents = true;
    this._agentService.getCalendar(
      this.partnerId,
      StaticUtils.formatDateForBackend(this._dateRange.start),
      this.datePickerRange === 0 ?
        StaticUtils.formatDateForBackend(this._dateRange.start) : StaticUtils.formatDateForBackend(this._dateRange.end),
      this._paxFilter
    ).subscribe(
      (res: AgentCalendar[]) => {
          this.calendar = this.fillMissingDays(res);
      },
      undefined,
      () => {
        this.loadingEvents = false;
      }
    );
  }

  fillMissingDays(calendar: AgentCalendar[]): AgentCalendar[] {
    const result = [];
    let previousDate: string;
    for (const calendarDay of calendar) {
      if (!previousDate) {
        previousDate = calendarDay.date;
      }
      const diff = moment(calendarDay.date).diff(moment(previousDate), 'days');
      if (diff > 1) {
        for (let i = 1; i < diff; i ++) {
          const newCalendarDay = new AgentCalendar();
          newCalendarDay.date = moment(previousDate).add(i, 'days').format('YYYY-MM-DD');
          newCalendarDay.products = [];
          result.push(newCalendarDay);
        }
      }
      previousDate = calendarDay.date;
      result.push(calendarDay);
    }
    return result;
  }

  today() {
    this._dateRange.start = moment();
    this._dateRange.end = this._dateRange.start.clone();
    this.datePickerRange = 0;
  }

  day() {
    this._dateRange.end = this._dateRange.start.clone();
    this.datePickerRange = 0;
  }

  week() {
    this._dateRange.end = this._dateRange.start.clone().add(8, 'days');
    this.datePickerRange = 7;
  }

  get dateRange(): any {
    return this._dateRange;
  }

  set dateRange(value: any) {
    this._dateRange = value;
    this._datePickerRange = this._dateRange.end.diff(this._dateRange.start, 'days') - 1;
    this.reloadEvents();
  }

  get paxFilter(): number {
    return this._paxFilter;
  }

  set paxFilter(value: number) {
    this._paxFilter = value;
    this.reloadEvents();
  }

  get datePickerRange(): number {
    return this._datePickerRange;
  }

  set datePickerRange(value: number) {
    this._datePickerRange = value;
    this.reloadEvents();
  }
}



// WEBPACK FOOTER //
// ./src/app/experiences/calendar/calendar.component.ts